export class AlertThreshold {
  low: number;
  medium_low: number;
  medium: number;
  medium_high: number;
  high: number;

  constructor() {
    this.low = null;
    this.medium_low = null;
    this.medium = null;
    this.medium_high = null;
    this.high = null;
  }
}

export class ThresholdLevels {
  static LOW = 'low';
  static MEDIUM_LOW = 'medium_low';
  static MEDIUM = 'medium';
  static MEDIUM_HIGH = 'medium_high';
  static HIGH = 'high';
  static UNDEFINED = 'undefined';
}
